import { TimeInMilliseconds } from '@malou-io/package-utils';

export const DELAY_TO_SCROLL_TO_SECTION = 0.1 * TimeInMilliseconds.SECOND;
export const DELAY_TO_SCROLL_TO_DELETED_BLOC_TOP = 1 * TimeInMilliseconds.SECOND;
export const DELAY_TO_SCROLL_TO_BLOC = 2.5 * TimeInMilliseconds.SECOND;
